import i18n from "@/i18n";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { PosterProduct } from "@/domain/entities/Booking";

const accountIsNonForeign = !AccountController.accountData.accountIsForeign;

const t = (key: string) => i18n.global.t(`booking.productPoster.legacyBookingMotto.${key}`);

export const productStyle: any = {
    sameday: {
        icon: "sameday",
        get motto() { return t("sameday"); },
        color: "#F09035",
        footer: {
            firstColor: "#ffffff",
            secondColor: "#FFDD5A",
        }
    },
    bosspack: {
        icon: "bosspack",
        get motto() { return t("bosspack"); },
        color: "#4f46a4",
        footer: {
            firstColor: "#ffffff",
            secondColor: "#6257ba",
        }
    },
    onepack: {
        icon: "onepack",
        get motto() { return t("onepack"); },
        color: "#8e78db",
        footer: {
            firstColor: "#ffffff",
            secondColor: "#e9deff",
        }
    },
    regpack: {
        icon: "regpack",
        get motto() { return t("regpack"); },
        color: "#238bcc",
        footer: {
            firstColor: "#ffffff",
            secondColor: "#d9f0ff",
        }
    },
    minipack: {
        icon: "minipack",
        get motto() { return t("minipack"); },
        color: "#FFD900",
        footer: {
            firstColor: "#ffffff",
            secondColor: "#FEFAE8",
        }
    },
    jagopack: {
        icon: "jagopack",
        get motto() { return t("jagopack"); },
        color: "#469c5e",
        footer: {
            firstColor: "#ffffff",
            secondColor: "#e3fcef",
        }
    },
    bigpack: {
        icon: "bigpack",
        get motto() { return t("bigpack"); },
        color: "#cd4425",
        footer: {
            firstColor: "#ffffff",
            secondColor: "#fcece7",
        }
    },
    bigpackfast: {
        icon: "bigpackfast",
        get motto() { return t("bigpackfast"); },
        color: "#cd4425",
        footer: {
            firstColor: "#ffffff",
            secondColor: "#fcece7",
        }
    },
    jumbopack: {
        icon: "jumbopack",
        get motto() { return t("jumbopack"); },
        color: "#a8ac7f",
        footer: {
            firstColor: "#ffffff",
            secondColor: "#b9bd8c7f",
        }
    },
    interpack: {
        icon: "interpack",
        get motto() { return t("interpack"); },
        color: "#d64f71",
        footer: {
            firstColor: "#ffffff",
            secondColor: "#f4dfe7",
        }
    },
    interpackmaxi: {
        icon: "interpackmaxi",
        get motto() { return t("interpackmaxi"); },
        color: "#d64f71",
        footer: {
            firstColor: "#ffffff",
            secondColor: "#f4dfe7",
        }
    },
    otopack150: {
        icon: "otopack-150",
        get motto() { return t("otopack"); },
        color: "#f09035",
        footer: {
            firstColor: "#ffffff",
            secondColor: "#fefae8",
        }
    },
    otopack250: {
        icon: "otopack-250",
        get motto() { return t("otopack"); },
        color: "#f09035",
        footer: {
            firstColor: "#ffffff",
            secondColor: "#fefae8",
        }
    },
    jumbopackh2h: {
        icon: "jumbopackh2h",
        get motto() { return t("jumbopackh2h"); },
        color: "#a8ac7f",
        footer: {
            firstColor: "#ffffff",
            secondColor: "#b9bd8c7f",
        }
    },
  vippack: {
    icon: "vippack",
    get motto() { return t("vippack"); },
    color: "#333333",
    footer: {
      firstColor: "#ffffff",
      secondColor: "#f0f0f0"
    },
  }
}

export const productHighlight: PosterProduct = {
    name: "BOSSPACK",
    icon: "bosspack",
    motto: t("bosspack"),
    price: "Rp-",
    sla: "-",
    color: "#a7a8aa",
    footer: {
        firstColor: "#ffffff",
        secondColor: "#a7a8aa",
    },
    discountAgentPrecentage: "-",
    discountAgentNominal: "-",
    statusCard: false,
    statusSelect: false,
    statusActive: false,
    isEmbargo: false
}

export const productSameday: PosterProduct = {
    name: "SAMEDAY",
    icon: "sameday",
    motto: t("sameday"),
    price: "Rp-",
    sla: "-",
    color: "#F09035",
    footer: {
        firstColor: "#ffffff",
        secondColor: "#FFDD5A",
    },
    discountAgentPrecentage: "-",
    discountAgentNominal: "-",
    statusCard: false,
    statusSelect: false,
    statusActive: false,
    isEmbargo: false
}

export const onePackProducts: PosterProduct[] = [
    {
        name: "onepack",
        icon: "onepack",
        motto: t("onepack"),
        price: "Rp-",
        sla: "-",
        color: "#a7a8aa",
        footer: {
            firstColor: "#ffffff",
            secondColor: "#d4d5d8",
        },
        discountAgentPrecentage: "-",
        discountAgentNominal: "-",
        statusCard: false,
        statusSelect: false,
        statusActive: false,
        isEmbargo: false
    }
]

export const mainProducts: PosterProduct[] = [
    {
        name: "regpack",
        icon: "regpack",
        motto: t("regpack"),
        price: "Rp-",
        sla: "-",
        color: "#a7a8aa",
        footer: {
            firstColor: "#ffffff",
            secondColor: "#d4d5d8",
        },
        discountAgentPrecentage: "-",
        discountAgentNominal: "-",
        statusCard: false,
        statusSelect: false,
        statusActive: false,
        isEmbargo: false

    },
    {
        name: "minipack",
        icon: "minipack",
        motto: t("minipack"),
        price: "Rp-",
        sla: "-",
        color: "#a7a8aa",
        footer: {
            firstColor: "#ffffff",
            secondColor: "#d4d5d8",
        },
        discountAgentPrecentage: "-",
        discountAgentNominal: "-",
        statusCard: false,
        statusSelect: false,
        statusActive: false,
        isEmbargo: false

    },
    {
        name: "jagopack",
        icon: "jagopack",
        motto: t("jagopack"),
        price: "Rp-",
        sla: "-",
        color: "#a7a8aa",
        footer: {
            firstColor: "#ffffff",
            secondColor: "#d4d5d8",
        },
        discountAgentPrecentage: "-",
        discountAgentNominal: "-",
        statusCard: false,
        statusSelect: false,
        statusActive: false,
        isEmbargo: false
        
    },
    {
        name: "jumbopack",
        icon: "jumbopack",
        motto: t("jumbopack"),
        price: "Rp-",
        sla: "-",
        color: "#a7a8aa",
        footer: {
            firstColor: "#ffffff",
            secondColor: "#d4d5d8",
        },
        discountAgentPrecentage: "-",
        discountAgentNominal: "-",
        statusCard: false,
        statusSelect: false,
        statusActive: false,
        isEmbargo: false

    },
    {
        name: "bigpack",
        icon: "bigpack",
        motto: t("bigpack"),
        price: "Rp-",
        sla: "-",
        color: "#a7a8aa",
        footer: {
            firstColor: "#ffffff",
            secondColor: "#d4d5d8",
        },
        discountAgentPrecentage: "-",
        discountAgentNominal: "-",
        statusCard: false,
        statusSelect: false,
        statusActive: false,
        isEmbargo: false

    },
    {
        name: "bigpackfast",
        icon: "bigpackfast",
        motto: t("bigpackfast"),
        price: "Rp-",
        sla: "-",
        color: "#a7a8aa",
        footer: {
            firstColor: "#ffffff",
            secondColor: "#d4d5d8",
        },
        discountAgentPrecentage: "-",
        discountAgentNominal: "-",
        statusCard: false,
        statusSelect: false,
        statusActive: false,
        isEmbargo: false

    },
    {
        name: "interpack",
        icon: "interpack",
        motto: t("interpack"),
        price: accountIsNonForeign ? "Rp-" : "RM",
        sla: "-",
        color: accountIsNonForeign ? "#a7a8aa" : "#d64f71",
        footer: {
            firstColor: "#ffffff",
            secondColor: accountIsNonForeign ? "#d4d5d8" : "#f4dfe7",
        },
        discountAgentPrecentage: "-",
        discountAgentNominal: "-",
        statusCard: !accountIsNonForeign,
        statusSelect: false,
        statusActive: !accountIsNonForeign,
        isEmbargo: false

    },
    {
        name: "interpackmaxi",
        icon: "interpackmaxi",
        motto: t("interpackmaxi"),
        price: accountIsNonForeign ? "Rp-" : "RM",
        sla: "-",
        color: accountIsNonForeign ? "#a7a8aa" : "#d64f71",
        footer: {
            firstColor: "#ffffff",
            secondColor: accountIsNonForeign ? "#d4d5d8" : "#f4dfe7",
        },
        discountAgentPrecentage: "-",
        discountAgentNominal: "-",
        statusCard: !accountIsNonForeign,
        statusSelect: false,
        statusActive: !accountIsNonForeign,
        isEmbargo: false

    },
    {
        name: "otopack150",
        icon: "otopack-150",
        motto: t("otopack"),
        price: "Rp-",
        sla: "-",
        color: "#a7a8aa",
        footer: {
            firstColor: "#ffffff",
            secondColor: "#d4d5d8",
        },
        discountAgentPrecentage: "-",
        discountAgentNominal: "-",
        statusCard: false,
        statusSelect: false,
        statusActive: false,
        isEmbargo: false

    },
    {
        name: "otopack250",
        icon: "otopack-250",
        motto: t("otopack"),
        price: "Rp-",
        sla: "-",
        color: "#a7a8aa",
        footer: {
            firstColor: "#ffffff",
            secondColor: "#d4d5d8",
        },
        discountAgentPrecentage: "-",
        discountAgentNominal: "-",
        statusCard: false,
        statusSelect: false,
        statusActive: false,
        isEmbargo: false
    },
  {
    name: "vippack",
    icon: "vippack",
    motto: t("vippack"),
    price: "Rp-",
    sla: "-",
    color: "#a7a8aa",
    footer: {
      firstColor: "#ffffff",
      secondColor: "#d4d5d8"
    },
    discountAgentPrecentage: "-",
    discountAgentNominal: "-",
    statusCard: false,
    statusSelect: false,
    statusActive: false,
    isEmbargo: false
  }
]

export const allProductsDefault: PosterProduct[] = [...onePackProducts, ...mainProducts];
export const allProductsWithoutOnePacks: PosterProduct[] = mainProducts;
